import type { EvaluationContext } from '@openfeature/web-sdk';

import type { AccountState } from '../../../reducers/account.reducer';

export type CurrentAppContext = {
  AppId?: string;
  OrgId?: string;
  CountryId?: string;
};

const ANONYMOUS_TARGETING_KEY = 'anonymous';
const ORG_TRAFFIC_TYPE = 'org_id';

// Split attribute names are case-sensitive. Some flags target `orgId`, others `OrgId`.
function orgIdAttributes(orgId: string): { orgId: string; OrgId: string } {
  return { orgId, OrgId: orgId };
}

export function buildFeatureFlagEvaluationContext(
  account: AccountState,
  currentApp: CurrentAppContext,
  isFlipdishStaff: boolean
): EvaluationContext {
  const userId = String(account.AccountId ?? ANONYMOUS_TARGETING_KEY);

  return {
    targetingKey: userId,
    userId,
    brandId: currentApp.AppId ?? '',
    countryCode: currentApp.CountryId ?? '',
    isFlipdishStaff,
    ...orgIdAttributes(currentApp.OrgId ?? ''),
  };
}

// Standard Split segments match only on the matching key, so org-scoped
// flags must be evaluated with the org id as the targeting key, on the
// org-keyed domain (see providers/harnessProvider.ts).
export function buildHarnessOrgFeatureFlagEvaluationContext(
  currentApp: CurrentAppContext
): EvaluationContext {
  const orgId = currentApp.OrgId ?? ANONYMOUS_TARGETING_KEY;

  return {
    targetingKey: orgId,
    trafficType: ORG_TRAFFIC_TYPE,
    countryCode: currentApp.CountryId ?? '',
    ...orgIdAttributes(orgId),
  };
}
